// const { getElement } = window.BAO.Utils
class YotpoPicturesWidget extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.checkPictureAmount()
  }

  checkPictureAmount () {
    this.waitForEl('.yotpo-display-wrapper.yotpo-slider').then(el => {
      const pictureCount = el.dataset.images
      if (pictureCount < 2) {
        this.style.display = 'none'
      }
      if (pictureCount < 3) {
        el.classList.add(
          `yotpo-image-count-less-than-three`,
          'yotpo-image-no-slide-contain',
        )
      }
    })
  }

  waitForEl (selector) {
    // eslint-disable-next-line
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector))
          observer.disconnect()
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })
  }
}

if (!customElements.get('yotpo-pictures-widget')) {
  customElements.define('yotpo-pictures-widget', YotpoPicturesWidget)
}
